/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassAttendanceRef,
  UnifiedClassAttendanceRefOptional,
  UnifiedClassAttendanceRefMetaI,
  UnifiedClassAttendanceRefTrackedI,
} from "./unified-class-attendance-ref";
import {
  UnifiedClassAttendanceRefTracked,
  UnifiedClassAttendanceRefMeta,
} from "./unified-class-attendance-ref";

/**
 *
 * @export
 * @interface JpClassAttendanceRef
 */
export interface JpClassAttendanceRefOptional extends UnifiedClassAttendanceRefOptional {
  /**
   *
   * @type {number}
   * @memberof JpClassAttendanceRef
   */
  assignId?: number;
}

export interface JpClassAttendanceRef
  extends JpClassAttendanceRefOptional, UnifiedClassAttendanceRef {
  /**
   *
   * @type {number}
   * @memberof JpClassAttendanceRef
   */
  assignId: number;
}

export interface JpClassAttendanceRefTrackedI extends UnifiedClassAttendanceRefOptional {
  /**
   *
   * @type {number}
   * @memberof JpClassAttendanceRef
   */
  assignId?: number;
  assignIdIsSet: boolean;
}

transformDatesMap.set(
  "JpClassAttendanceRef",
  function (model: JpClassAttendanceRef) {},
);

export type JpClassAttendanceRefMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
}>;

export var JpClassAttendanceRefMeta: JpClassAttendanceRefMetaI =
  {} as JpClassAttendanceRefMetaI;
JpClassAttendanceRefMeta = typeMeta("JpClassAttendanceRef", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
});

const metaI = JpClassAttendanceRefMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([UnifiedClassAttendanceRefMeta]);
  metaI.assignId.inheritedFrom = UnifiedClassAttendanceRefMeta.assignId;
});

export class JpClassAttendanceRefTracked
  extends UnifiedClassAttendanceRefTracked
  implements JpClassAttendanceRefTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  constructor(config?: JpClassAttendanceRefOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: JpClassAttendanceRefOptional,
    options?: AssignOptions,
  ): JpClassAttendanceRefTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): JpClassAttendanceRefTrackedI {
    const cloned = {} as JpClassAttendanceRefTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): JpClassAttendanceRefTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassAttendanceRefMeta.assignId,
      JpClassAttendanceRefMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
